import { ValidationItemModel } from './ValidationItemModel';

export class ListDataResponseModel {
    isSuccess: boolean;
    affectedRecords: number;
    endUserMessage: string;
    validationErrors: [ValidationItemModel];
    result: Array<any>;
}
